import { toast } from 'sonner';

import type { CSSProperties } from 'react';

const toastOptions = (duration?: number) =>
  duration === undefined
    ? undefined
    : {
        duration,
        style: { '--toast-duration': `${duration}ms` } as CSSProperties,
      };

export class DisplayToast {
  static success(message: string, duration?: number) {
    toast.success(message, toastOptions(duration));
  }

  static notice(message: string, duration?: number) {
    toast.success(message, toastOptions(duration));
  }

  static error(message?: string, duration?: number) {
    toast.error(message || 'Щось пішло не так', toastOptions(duration));
  }
}
